import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { setLenis } from "./lib/scroll";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Process } from "./components/Process";
import { Services } from "./components/Services";
import { Waste } from "./components/Waste";
import { Why } from "./components/Why";
import { Coverage } from "./components/Coverage";
import { FAQ } from "./components/FAQ";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="App bg-[#0B0C10] text-[#F5F5F7] font-body">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Process />
        <Services />
        <Waste />
        <Why />
        <Coverage />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-center" />
    </div>
  );
}

export default App;
